/* eslint-disable prettier/prettier */
import { CourseSummary } from '../types/course';
import ProgramPlaceholderImage from '../assets/images/ProgramMainImg.jpg';
import { ProgramData } from '../types/program';
export const mapCourseToProgramData = (course: CourseSummary): ProgramData => {
	const dateObj = new Date(course.createdat);

	return {
		id: course.id,
		title: course.title,
		solutiontitle: course.solutiontitle || '--',
		category: course.category,
		imageUrl: course.coverimage
			? `${process.env.REACT_APP_BASE_API_URL}/course/${course.id}/cover`
			: ProgramPlaceholderImage,

		programformat: course.programformat || '--',

		programownerid: course.programownerid,

		faculty: course.faculty,
		
		hours: course.duration, // Backend duration string
		status: course.status,
		resourceCount: 0, // You can map this if your backend provides it later
		date: dateObj.getDate().toString(),
		month: dateObj
			.toLocaleString('default', { month: 'short' })
			.toUpperCase(),
		// statusText: course.difficulty.toUpperCase(),
		hasLiveEvents: course.deliverymode === 'live',
		// modules: course.maxenrollments?.toFixed || 0,
		certification: course.certification,
		startdate: course.startdate
			? new Date(course.startdate).toISOString()
			: '',
		enddate: course.enddate ? new Date(course.enddate).toISOString() : '',
	};
};
